import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { inputCls, labelCls } from "./AuthShell";
import { http, formatApiErrorDetail } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function Reset() {
  useSeo({ title: "Choose New Password | Infant Sleep Consultant Near Me Education Center", noindex: true });
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await http.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Choose a new password" footer={<Link to="/login" className="text-[#C2836B] hover:underline">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className={labelCls}>New password</label>
          <input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} minLength={6} required />
        </div>
        {err && <p data-testid="reset-error" className="text-[#e08a8a] text-sm">{err}</p>}
        <button data-testid="reset-submit" disabled={busy} className="btn-clay w-full py-3 rounded-full text-sm disabled:opacity-60">{busy ? "Saving…" : "Reset password"}</button>
      </form>
    </AuthShell>
  );
}
